import React, { useContext } from 'react';
import type { Store } from 'src/types';
import { AppContext } from 'src/components/app-context';
import {
  getGroupedPaymentProviders,
  getPaymentProviders,
} from 'src/components/store-payment/utils';
import {
  PaymentProviderLogotype,
  PaymentProviderMoreLabel,
  PaymentProviders,
} from './styles';
import type { IPaymentProvider } from 'src/components/store-payment/types';
import { H4Text } from '@prisjakt/ui/text/variants';

export const OfferPaymentProviders: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IPaymentProvidersProps>>
> = ({ store, showAll, limit }) => {
  const { market, t } = useContext(AppContext);
  const paymentProviders = getPaymentProviders(store, market);
  const providers = getGroupedPaymentProviders(store, market);
  let visibleProviders: IPaymentProvider[] = providers;

  if (limit && providers?.length > limit) {
    visibleProviders = providers.slice(0, limit);
  }

  const invisibleProviders: IPaymentProvider[] =
    paymentProviders.providers.filter(
      p => p.active && !visibleProviders.find(v => v.name === p.name)
    );

  if (!paymentProviders.hasProviders) {
    return null;
  }

  return (
    <>
      <H4Text>{t('store', 'store.payment-options')}</H4Text>
      <PaymentProviders>
        {showAll &&
          paymentProviders.providers.map(
            provider =>
              Boolean(provider.active) && (
                <PaymentProviderLogotype
                  src={provider.logoUrl}
                  alt={provider.label}
                  title={provider.label}
                  key={provider.name}
                />
              )
          )}
        {!showAll &&
          visibleProviders.map(provider => (
            <PaymentProviderLogotype
              src={provider.logoUrl}
              alt={provider.label}
              title={provider.label}
              key={provider.name}
            />
          ))}
        {!showAll && invisibleProviders.length > 0 && (
          <PaymentProviderMoreLabel>
            <span>+</span>
            {invisibleProviders.length}
          </PaymentProviderMoreLabel>
        )}
      </PaymentProviders>
    </>
  );
};

interface IPaymentProvidersProps {
  store: Store;
  showAll?: boolean;
  limit?: number;
}
